import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('portals-platform-lib', {
  library: 'portals-platform-lib'
});